import React, { Component } from 'react';
import Slider from 'react-slick';
import StarRatings from 'react-star-ratings';
import { CFAExamList, GMATExamList } from '../../../common/constant';
import App_data from '../../config/App_data';

export default class Tutor2023 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  slider;
  static contextTypes = { router: React.PropTypes.object };

  render() {
    const Exams = localStorage.getItem('selectedmenu');
    const settings = {
      infinite: true,
      speed: 1000,
      slidesToShow: 2,
      slidesToScroll: 1,
      // autoplay: true,
      initialSlide: 0,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
      <div className='card guru-head-wrapper'>
        {CFAExamList().some((exam) => exam.value === Exams) ? (
          <div className='row all-rows'>
            <div className='col-lg-3  guru-logo'>
              <div>
                <img src={`${App_data.frontend_url}/img/APmyguru.jpg`} alt='APmyguru.jpg' />
              </div>
            </div>
            <div className='col-lg-9  logo-head-section'>
              <h2>What My Guru Offers</h2>
              <div className='logo-head-section-inner1'>
                <div>
                  <p>
                    AnalystPrep, in partnership with George Beshara and MyGuru, offers a live,
                    dynamic, interactive, one-on-one online learning experience at nearly half the
                    cost of comparable online instructors by using free, intuitive online
                    white-boarding and live videoconferencing technology. We rely on our expert
                    online tutors to design highly personalized remote learning experiences. We
                    begin every session with an empty whiteboard and end with a comprehensive set of
                    instructor-generated notes illustrating that day's lesson. After every online
                    tutoring session students have the option to review their notes anytime in PDF
                    form.
                  </p>
                </div>
              </div>
              <div className='logo-head-section-inner2'>
                <div>
                  {/* <span>
                    We also offer "premium" online tutoring with two key benefits:
                  </span> */}
                  <p>
                    <img src={`${App_data.frontend_url}/img/tick.jpg`} alt='tick.jpg' />
                    Every session is recorded for later review and you can pose questions on the
                    online whiteboard at any time. This notifies the instructor, who will respond to
                    you within 24 hours. So your online tutoring experience extends beyond the 90
                    minutes of live online coaching you receive each week.
                  </p>
                  {/* <p>
                    <img src={App_data.frontend_url + '/img/tick.jpg'} />
                    b) You can pose questions on the online whiteboard at any
                    time. This notifies the instructor, who will respond to you
                    within 24 hours. So your online tutoring experience extends
                    beyond the 1-2 hours of live online coaching you receive each
                    week.
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        ) : GMATExamList.some((exam) => exam.value === Exams) ? (
          <div className='row all-rows'>
            <div className='col-lg-3  guru-logo'>
              <div>
                <img src={`${App_data.frontend_url}/img/APmyguru.jpg`} alt='APmyguru.jpg' />
              </div>
            </div>
            <div className='col-lg-9  logo-head-section'>
              <h2>What My Guru Offers</h2>
              <div className='logo-head-section-inner1'>
                <div>
                  <p>
                    MyGuru offers a live, dynamic, interactive, one-on-one online learning
                    experience at nearly half the cost of comparable online instructors by using
                    free, intuitive online white-boarding and live videoconferencing technology. We
                    rely on our expert online tutors to design highly personalized remote learning
                    experiences. We begin every session with an empty whiteboard and end with a
                    comprehensive set of instructor-generated notes illustrating that day's lesson.
                    After every online tutoring session students have the option to review their
                    notes anytime in PDF form.
                  </p>
                </div>
              </div>
              <div className='logo-head-section-inner2'>
                <div>
                  <span>We also offer "premium" online tutoring with two key benefits:</span>
                  <p>
                    <img src={`${App_data.frontend_url}/img/tick.jpg`} alt='tick.jpg' />
                    a) Every session is recorded for later review and
                  </p>
                  <p>
                    <img src={`${App_data.frontend_url}/img/tick.jpg`} alt='tick.jpg' />
                    b) You can pose questions on the online whiteboard at any time. This notifies
                    the instructor, who will respond to you within 24 hours. So your online tutoring
                    experience extends beyond the 1-2 hours of live online coaching you receive each
                    week.
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}

        <div>
          <hr className='hr-text' data-content='PLANS' />
        </div>

        <section className='plans-wrapper'>
          <div className='row all-rows'>
            {/* <div className="col-lg-5 ">
              <div className="card common-mid-wrapper ">
                <div>
                  <img src={`${App_data.frontend_url}/img/standard.webp`}/>
                </div>
                <h5>Standard Tutoring Session</h5>
                <ul className="arrow">
                  <li>FRM Tutoring</li>
                  <li>CFA Tutoring</li>

                  <li>Actuarial Exams Tutoring</li>

                  <li>MBA Admission Tutoring</li>
                </ul>
                <ul className="curved-round">
                  <li>$100 - 1h of Standard Online 1-on-1 Tutoring Sessions</li>
                  <li>$350 - 5h of Standard Online 1-on-1 Tutoring Sessions</li>
                </ul>
                <div className="action-btn-wrapper">
                <a href="https://analystprep.com/shop/1-on-1-online-tutoring-by-myguru-and-analystprep/" target="blank" className="btn btn-primary pointer_class standard-btn">
                  More Details
                </a>
              </div>
              </div>
            </div>
            <div className='col-lg-2'>

            </div> */}

            {CFAExamList().some((exam) => exam.value === Exams) ? (
              <div className='col-lg-5 '>
                <div className='card common-mid-wrapper premium-plan'>
                  <div>
                    <img src={`${App_data.frontend_url}/img/premium1.webp`} alt='premium1.webp' />
                  </div>
                  <h5> 1-on-1 Online CFA® Program Tutoring</h5>
                  {/* <ul className='arrow'>
                    <li>FRM Tutoring</li>
                    <li>CFA Tutoring</li>

                    <li>Actuarial Exams Tutoring</li>

                    <li>MBA Admission Tutoring</li>
                  </ul> */}
                  <ul className='curved-round'>
                    <li>Private, 1 on 1 instruction</li>
                    <li>Award-winning virtual options</li>
                    <li>Highly customized study plans</li>
                    <li>Homework assignments & regular practice tests</li>
                    <li>Skills-based & critical thinking oriented</li>
                  </ul>
                  <div className='action-btn-wrapper'>
                    <a
                      href='https://analystprep.com/shop/1-on-1-online-cfa-program-tutoring-by-george-beshara/'
                      target='blank'
                      className='btn btn-primary pointer_class premium-btn'
                    >
                      More Details
                    </a>
                  </div>
                </div>
              </div>
            ) : GMATExamList.some((exam) => exam.value === Exams) ? (
              <div className='col-lg-5 '>
                <div className='card common-mid-wrapper premium-plan'>
                  <div>
                    <img src={`${App_data.frontend_url}/img/standard.webp`} alt='premium1.webp' />
                  </div>
                  <h5>1-on-1 Online GMAT/EA Program Tutoring</h5>
                  {/* <ul className='arrow'>
                    <li>Private, 1 on 1 instruction</li>
                    <li>Award-winning virtual options</li>

                    <li>Highly customized study plans</li>

                    <li>Homework assignments & regular practice tests</li>
                    <li>Skills-based & critical thinking oriented</li>

                  </ul> */}
                  <ul className='curved-round'>
                    <li>Private, 1 on 1 instruction</li>
                    <li>Award-winning virtual options</li>
                    <li>Highly customized study plans</li>
                    <li>Homework assignments & regular practice tests</li>
                    <li>Skills-based & critical thinking oriented</li>
                  </ul>
                  <div className='action-btn-wrapper'>
                    <a
                      href='https://analystprep.com/shop/1-on-1-online-tutoring-by-myguru-and-analystprep/'
                      target='blank'
                      className='btn btn-primary pointer_class premium-btn'
                    >
                      More Details
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}

            {/* <div className="col-lg-4 product-wrapper-icon">
              <div>
                <img src={App_data.frontend_url + "/img/computer.png"} />
              </div>
              <div className="action-btn-wrapper">
                <button className="btn btn-primary pointer_class">
                  More Details
                </button>
              </div>
            </div> */}
          </div>
        </section>

        <div>
          <hr className='hr-text' data-content='REVIEWS' />
        </div>
        <section className='review-section all-rows'>
          <Slider {...settings}>
            <div className='slider-outer-wrapper'>
              <div className='review-wrapper'>
                <div className='row slider-flex-wrapper'>
                  <div className='col-lg-3'>
                    <img src={`${App_data.frontend_url}/img/dummy.jpg`} alt='dummy.jpg' />
                    <p>
                      <i>- Jessie S.</i>w
                    </p>
                    <div className='star-review'>
                      <StarRatings
                        starDimension='15px'
                        starEmptyColor='rgb(255, 180, 0)'
                        starSpacing='0px'
                        numberOfStars={5}
                      />
                    </div>
                  </div>
                  <div className='col-lg-9'>
                    <p>
                      Stefan was awesome! He brought up my Verbal from the 40th to 76th percentile.
                      I would definitely use him again. Very affordable, very high quality. I went
                      from a 650 to a 690 in a very tight timeframe.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='slider-outer-wrapper'>
              <div className='review-wrapper'>
                <div className='row slider-flex-wrapper'>
                  <div className='col-lg-3'>
                    <img src={`${App_data.frontend_url}/img/dummy.jpg`} alt='dummy.jpg' />
                    <p>
                      <i>- Alex S.</i>
                    </p>
                    <div className='star-review'>
                      <StarRatings
                        starDimension='15px'
                        starEmptyColor='rgb(255, 180, 0)'
                        starSpacing='0px'
                        numberOfStars={5}
                      />
                    </div>
                  </div>
                  <div className='col-lg-9'>
                    <p>
                      I raised my score by 80 points in 8 weeks. I worked with Stefan for two months
                      and was able to raise my GMAT score 80 points in order to apply to competitive
                      MBA programs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='slider-outer-wrapper'>
              <div className='review-wrapper'>
                <div className='row slider-flex-wrapper'>
                  <div className='col-lg-3'>
                    <img src={`${App_data.frontend_url}/img/dummy.jpg`} alt='dummy.jpg' />
                    <p>
                      <i>- Alexandra G.</i>
                    </p>
                    <div className='star-review'>
                      <StarRatings
                        starDimension='15px'
                        starEmptyColor='rgb(255, 180, 0)'
                        starSpacing='0px'
                        numberOfStars={5}
                      />
                    </div>
                  </div>
                  <div className='col-lg-9'>
                    <p>
                      Amazing people all around, from the manager, Morgan, to the tutor, Adam!!
                      Prompt, professional communication and top quality tutoring. My son found the
                      ACT prep very valuable and improved his composite score by 6 points. Highly
                      recommend!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='slider-outer-wrapper'>
              <div className='review-wrapper'>
                <div className='row slider-flex-wrapper'>
                  <div className='col-lg-3'>
                    <img src={`${App_data.frontend_url}/img/dummy.jpg`} alt='dummy.jpg' />
                    <p>
                      <i>- Emily L.</i>
                    </p>
                    <div className='star-review'>
                      <StarRatings
                        starDimension='15px'
                        starEmptyColor='rgb(255, 180, 0)'
                        starSpacing='0px'
                        numberOfStars={5}
                      />
                    </div>
                  </div>
                  <div className='col-lg-9'>
                    <p>
                      I prepared for the GMAT under Stefan. It was super easy to use the online
                      platform and was very convenient to save notes this way. Stefan is extremely
                      knowledgable on the testing material and really cares about his students.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='slider-outer-wrapper'>
              <div className='review-wrapper'>
                <div className='row slider-flex-wrapper'>
                  <div className='col-lg-3'>
                    <img src={`${App_data.frontend_url}/img/dummy.jpg`} alt='dummy.jpg' />
                    <p>
                      <i>- Abigail M.</i>
                    </p>
                    <div className='star-review'>
                      <StarRatings
                        starDimension='15px'
                        starEmptyColor='rgb(255, 180, 0)'
                        starSpacing='0px'
                        numberOfStars={5}
                      />
                    </div>
                  </div>
                  <div className='col-lg-9'>
                    <p>
                      I worked with Steve Markofsky. He was very professional, amiable, and flexible
                      with my work schedule. I received my desired scores! Thank you, Steve.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='slider-outer-wrapper'>
              <div className='review-wrapper'>
                <div className='row slider-flex-wrapper'>
                  <div className='col-lg-3'>
                    <img src={`${App_data.frontend_url}/img/dummy.jpg`} alt='dummy.jpg' />
                    <p>
                      {' '}
                      <i>- Izzi S.</i>
                    </p>
                    <div className='star-review'>
                      <StarRatings
                        starDimension='15px'
                        starEmptyColor='rgb(255, 180, 0)'
                        starSpacing='0px'
                        numberOfStars={5}
                      />
                    </div>
                  </div>
                  <div className='col-lg-9'>
                    <p>
                      I studied with Steve Markofsky, he was always so helpful. When I was confused,
                      he took time to explain the topics slowly and simply. 100% recommend this
                      tutoring service!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </section>
      </div>
    );
  }
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', background: 'red' }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', background: 'green' }}
      onClick={onClick}
    />
  );
}



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Tutor2023/Tutor2023.js